import { CurrentRecordState } from './state/index';
import { Field } from './types';

const formatComplaints = (
  complaints: CurrentRecordState['complaints'],
  fields: Field[],
) => {
  complaints.ids.forEach((id) => {
    fields.push({
      type: 'COMPLAINT',
      title: complaints.entities[id]?.title,
      description: complaints.entities[id]?.description,
    });
  });
};

export const patientHistoryTypeMap: Record<string, string> = {
  clinicalBackground: 'CLINICAL_HISTORY',
  medication: 'ONGOING_MEDICATION',
  surgicalHistory: 'SURGERY_HISTORY',
  allergies: 'ALLERGIES',
  habits: 'LIFESTYLE_HABITS',
  familyBackground: 'FAMILY_HISTORY',
};

const formatPatientHistory = (
  patientHistory: CurrentRecordState['patientHistory'],
  fields: Field[],
) => {
  Object.keys(patientHistory).forEach((key) => {
    fields.push({
      type: patientHistoryTypeMap[key],
      description: patientHistory[key].observation,
      is_present: patientHistory[key].response,
    });
  });
};

export const currentRecordToFields = (currentRecord: CurrentRecordState) => {
  const fields: Field[] = [];

  formatComplaints(currentRecord.complaints, fields);
  formatPatientHistory(currentRecord.patientHistory, fields);

  return fields;
};
